module.exports = __webpack_public_path__ + "media/images/banner_clube-c9742e1bc849e872681df80dd6817085.png";